import React, { Component } from "react";
import { Route } from "react-router";
import EmptyLayout from "./EmptyLayout";

interface Props {
  component: any;
  path?: string;
  exact?: boolean;
  contextLevel?: string;
}

export const EmptyLayoutRoute = (props: Props) => {
  const { component: Component, ...rest } = props;

  return (
    <Route
      {...rest}
      render={(props) => (
        <EmptyLayout>
          <Component {...props} />
        </EmptyLayout>
      )}
    />
  );
};
